export class FreeWheelGPDR {
    optanonInstance;

    constructor(optanonInstance) {
        this.optanonInstance = optanonInstance;
    }

    getGPDRData() {
        return new Promise((resolve) => {
            this.optanonInstance.tcf.getConsentData((data, successful) => {
                let gdpr_consent = successful ? data.tcString : null;
                let gdpr = data?.gdprApplies ? 1 : 0;
                resolve({
                    gdpr_consent,
                    gdpr,
                });
            });
        });
    }
}
